<template>
  <v-card
    :loading="loading"
    class="pa-0"
  >
    <v-card-title> Types </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
        :items="types"
        :headers="headers"
        item-key="id"
        :items-per-page="-1"
      >
        <template #[`item.actions`]="{ item }">
          <v-btn
            color="mcsprimary"
            class="ml-2"
            @click="edit(item)"
          >
            Edit
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
    <Edit ref="editType" />
  </v-card>
</template>

<script>
import Edit from '@/components/content/pages/Edit';
import { mapGetters } from 'vuex';
export default {
  components: { Edit },
  data() {
    return {
      loading: false,
      saving: false
    };
  },

  computed: {
    headers() {
      const list = [
        { text: 'Id', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: '', value: 'actions', sortable: false }
      ];
      return list.filter((x) => !x.hide);
    },
    ...mapGetters({
      types: 'lookup/content_page_types'
    })
  },

  methods: {
    edit(item) {
      this.$refs.editType.showType(item);
    }
  }
};
</script>
